<div class="sysconf-container">
  
  <div class="dash-header" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
    <div>
      <h1 class="cyber-title">>_ BÓVEDA DE CONFIGURACIÓN (E2DB)</h1>
      <p class="subtitle">Gestión de secretos, variables de entorno y parámetros IA.</p>
    </div>
    
    <div class="filter-box">
      <span class="tenant-label">ENTORNO A CONFIGURAR:</span>
      <select class="cyber-select" [(ngModel)]="selectedTenantFilter" (ngModelChange)="onFilterChange()">
        <option value="">⚡ MODO GLOBAL (Por Defecto)</option>
        <option *ngFor="let t of tenants" [value]="t.id">🏢 CLIENTE: {{ t.name }}</option>
      </select>
    </div>
  </div>

  <div class="conf-grid">
    
    <div class="surface form-section">
      <h3 class="card-title" style="margin-top:0;">{{ isEditing ? 'EDITAR VARIABLE' : 'NUEVA VARIABLE' }}</h3>
      
      <form [formGroup]="configForm" (ngSubmit)="saveConfig()">
        <div class="form-group">
          <label class="modal-label">Clave (Key)</label>
          <input type="text" class="form-control form-control-sm" formControlName="key" placeholder="Ej: OPENAI_API_KEY">
        </div>
        
        <div class="form-group">
          <label class="modal-label">Valor (Value)</label>
          <textarea class="form-control form-control-sm" formControlName="value" rows="4" placeholder="El valor de la clave..."></textarea>
        </div>

        <div class="checkbox-group" style="margin-top: 15px; margin-bottom: 20px; display: flex; gap: 20px;">
          <label style="color: #a0aec0; font-size: 12px; display: flex; align-items: center; gap: 5px;">
            <input type="checkbox" formControlName="is_public"> Pública (Frontend)
          </label>
          <label style="color: #ff5f56; font-size: 12px; display: flex; align-items: center; gap: 5px;" title="Cifrar en base de datos">
            <input type="checkbox" formControlName="is_secret"> 🔒 Secreto E2DB
          </label>
        </div>

        <div style="display: flex; gap: 10px;">
          <button type="button" class="btn secondary sm" (click)="resetForm()" *ngIf="isEditing">CANCELAR</button>
          <button type="submit" class="btn primary sm" [disabled]="configForm.invalid" style="flex: 1;">
            {{ isEditing ? 'ACTUALIZAR EN BÓVEDA' : 'GUARDAR' }}
          </button>
        </div>
      </form>

      <div *ngIf="selectedTenantFilter !== ''" style="margin-top: 20px; padding: 10px; border: 1px dashed #ffbd2e; color: #ffbd2e; font-size: 11px; background: rgba(255, 189, 46, 0.05); border-radius: 4px;">
        ⚠️ Estás editando overrides. Estas variables sobrescribirán a las globales únicamente para este cliente.
      </div>
    </div>

    <div class="surface list-section" style="flex: 1;">
      <table class="cyber-table compact">
        <thead>
          <tr>
            <th>CLAVE (KEY)</th>
            <th>VALOR</th>
            <th style="text-align: center;">TIPO</th>
            <th style="text-align: right;">ACCIONES</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of filteredConfigs">
            <td style="font-weight: bold; color: var(--dl-color-theme-primary1);">{{ c.key }}</td>
            
            <td style="width: 45%;">
              <div style="display: flex; align-items: flex-start; gap: 10px;">
                
                <ng-container *ngIf="c.is_secret && !revealMap[c.id]">
                  <input type="password" class="form-control form-control-sm readonly-input" [value]="c.value" readonly>
                </ng-container>
                
                <ng-container *ngIf="!c.is_secret || revealMap[c.id]">
                  <textarea class="form-control form-control-sm readonly-input" [value]="c.value" readonly rows="2"></textarea>
                </ng-container>
                
                <button *ngIf="c.is_secret" class="icon-btn" (click)="toggleReveal(c.id)" title="Revelar Secreto" style="margin-top: 5px;">
                  {{ revealMap[c.id] ? '🙈' : '👁️' }}
                </button>
              </div>
            </td>

            <td style="text-align: center;">
              <span class="badge-status" *ngIf="c.is_secret" style="background: rgba(255, 95, 86, 0.2); color: #ff5f56;">SECRETO</span>
              <span class="badge-status" *ngIf="c.is_public" style="background: rgba(102, 217, 239, 0.2); color: #66d9ef;">PÚBLICO</span>
              <span class="badge-status" *ngIf="!c.is_secret && !c.is_public">INTERNO</span>
            </td>

            <td style="text-align: right;">
              <button class="btn secondary sm" (click)="editConfig(c)" style="margin-right: 5px;">EDITAR</button>
              <button class="btn danger sm" (click)="deleteConfig(c.id)">DEL</button>
            </td>
          </tr>
          
          <tr *ngIf="filteredConfigs.length === 0">
            <td colspan="4" style="text-align: center; color: #666; padding: 20px;">
              No hay variables {{ selectedTenantFilter ? 'sobrescritas para este cliente' : 'globales' }}.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>